<script>
  export default {
    props: ['data'],
    methods: {
      isDefaultFee(list, period) {
        // eslint-disable-next-line eqeqeq
        return list.find(s => s.period == period)?.isDefaultFee === false
      },
    },
  }
</script>

<template>
  <table class="text-center table-price table-bordered table-responsive">
    <thead>
      <tr class="text-center bg-head2">
        <th width="15%" rowspan="2"><b>Ngân hàng</b></th>
        <th colspan="8"><b>Kỳ hạn trả góp</b></th>
        <th id="th8" width="15%" rowspan="2">
          <b>Mức giao dịch tối thiểu (VNĐ)</b>
        </th>
      </tr>
      <tr class="text-center bg-head2">
        <th id="th1" width="10%"><b>3 tháng</b></th>
        <th id="th2" width="10%"><b>6 tháng</b></th>
        <th id="th3" width="10%"><b>9 tháng </b></th>
        <th id="th4" width="10%"><b>12 tháng </b></th>
        <th id="th5" width="10%"><b>18 tháng</b></th>
        <th id="th6" width="10%"><b>21 tháng</b></th>
        <th id="th7" width="10%"><b>24 tháng</b></th>
        <th width="10%"><b>36 tháng</b></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <td class="txt-center">{{ item.bankName }}</td>
        <td class="txt-center">
          <span :class="isDefaultFee(item.listPeriod, 3) && 'bg-yellow'">
            {{ '3' | mapA(item.listPeriod) }}
          </span>
        </td>
        <td class="text-center">
          <span :class="isDefaultFee(item.listPeriod, 6) && 'bg-yellow'">
            {{ '6' | mapA(item.listPeriod) }}
          </span>
        </td>
        <td class="txt-center">
          <span :class="isDefaultFee(item.listPeriod, 9) && 'bg-yellow'">
            {{ '9' | mapA(item.listPeriod) }}
          </span>
        </td>
        <td class="text-center">
          <span :class="isDefaultFee(item.listPeriod, 12) && 'bg-yellow'">
            {{ '12' | mapA(item.listPeriod) }}
          </span>
        </td>
        <td class="text-center">
          <span :class="isDefaultFee(item.listPeriod, 18) && 'bg-yellow'">
            {{ '18' | mapA(item.listPeriod) }}
          </span>
        </td>
        <td class="text-center">
          <span :class="isDefaultFee(item.listPeriod, 21) && 'bg-yellow'">
            {{ '21' | mapA(item.listPeriod) }}
          </span>
        </td>
        <td class="text-center">
          <span :class="isDefaultFee(item.listPeriod, 24) && 'bg-yellow'">
            {{ '24' | mapA(item.listPeriod) }}
          </span>
        </td>
        <td class="text-center">
          <span :class="isDefaultFee(item.listPeriod, 36) && 'bg-yellow'">
            {{ '36' | mapA(item.listPeriod) }}
          </span>
        </td>
        <td class="text-center">
          {{ item.minAmount | fomatCurrency }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
